import locTypeCascader from "./locTypeCascader.vue";
export default locTypeCascader;
